import { z } from "zod";
import { LessonId } from "./room.ts";

export const TokenResponse = z.object({
  token: z.string(),
  /** URL SFU приходит с сервера, а не зашивается в бандл: см. runtime-config. */
  url: z.string().url(),
  lessonId: LessonId,
  identity: z.string(),
  expiresAt: z.number().int(),
  /**
   * Сколько человек помещается в ЭТУ комнату, считая самого спрашивающего.
   *
   * ⚠️ **Число приезжает с сервера, а не считается на клиенте**, и это условие
   * 7 рубежа включения (`docs/group-room-design.md`, раздел 17). Вместимость
   * ставится при создании комнаты (`ensureRoom`), и она же единственный
   * источник истины: зашитый в бандл литерал соврёт молча в тот день, когда
   * вместимость станет свойством преподавателя. Ровно так и было до
   * 01.09.2026: `slice(0, 3)` в `VideoOverlay.tsx` с комментарием «три это
   * вместимость минус мы сами».
   *
   * Необязательное: в открытой вкладке крутится бандл, выданный до этой
   * правки, и ответ обязан разбираться обеими версиями схемы.
   */
  capacity: z.number().int().positive().optional(),
});
export type TokenResponse = z.infer<typeof TokenResponse>;
